import { Instance } from 'mobx-state-tree';
import ParticlesPlusSensor from './model';

export interface IParticlesPlusSensor extends Instance<typeof ParticlesPlusSensor> {}

export default ParticlesPlusSensor;
